import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {GuiPermissionsService} from '../_services/gui/gui-permissions.service';
import {switchMapIfFalse} from '../_utils/operators';

@Injectable({
  providedIn: 'root'
})
export class ViewUserGuard  {
  private readonly guiPermissionsService = inject(GuiPermissionsService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return switchMapIfFalse(this.guiPermissionsService.canViewUser(next.params.userId), this.guiPermissionsService.companyAdminRedirectUrlTree$);
  }
  
}
